<clr-main-container>
  <!-- Bandeau backend indisponible -->
  @if (backendUnavailable$ | async) {
    <div class="alert alert-app-level alert-danger" role="alert">
      <div class="alert-items">
        <div class="alert-item static">
          <div class="alert-icon-wrapper">
            <clr-icon class="alert-icon" shape="exclamation-circle"></clr-icon>
          </div>
          <div class="alert-text">
            L'application rencontre un problème technique. Certaines informations peuvent ne pas s'afficher correctement. Veuillez contacter votre administrateur.
          </div>
        </div>
      </div>
    </div>
  }

  <!-- AppLevel Message -->
  @if (alertAppLevelMessage !== '') {
    <div class="alert alert-app-level alert-warning" role="alert">
      <div class="alert-items">
        <div class="alert-item static">
          <div class="alert-icon-wrapper">
            <clr-icon class="alert-icon" shape="info"></clr-icon>
          </div>
          <div class="alert-text">{{ alertAppLevelMessage }}</div>
          <div class="alert-actions"></div>
        </div>
      </div>
      <button type="button" class="close" aria-label="Close">
        <cds-icon aria-hidden="true" shape="close"></cds-icon>
      </button>
    </div>
  }

  <!-- Header -->
  <app-header [showPerimetre]="true"></app-header>

  <!-- Content -->
  <div class="content-container">
    <app-sidebar class="app-sidebar"></app-sidebar>
    <div class="content-area">
      <!-- Router -->
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-alert-dialog></app-alert-dialog>
</clr-main-container>
